import React from "react";
import styled from "styled-components";
import { device, mq } from "lib/media-query";

type ResponsiveBlockCompProps = React.HTMLProps<HTMLDivElement>;

export const ResponsiveBlock = styled.div<ResponsiveBlockCompProps>`
    display: block;
    margin: 0 auto;
    width: 100%;
    max-width: 1296px;

    ${mq.to(device.TABLET)`
    max-width: 100%;
  `}
`;
